// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Define HTTP method request enum.
 * @author James Reid
 */

// @ts-check

// @@no-imports

// @@body
// Callbacks:
/**
 * Custom callback to be called *after* request error modal is dismissed,
 * and *before* page is reloaded following modal dismissal.
 * @callback requestErrorCb
 * @returns {void} Request error callback should return no value, as page will
 * be immediately reloaded after execution.
 */

// Enums:
/**
 * HTTP method type enum. See [here](https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Methods)
 * for options.
 * @typedef {"GET"|"HEAD"|"POST"|"PUT"|"DELETE"|"CONNECT"|"OPTIONS"|"TRACE"|"PATCH"} HttpMethod // @no-wrap
 */

// @@exports
// Callbacks:
/**
 * @type {requestErrorCb}
 * @ignore
 */
export let requestErrorCb

// Enums:
/**
 * @type {HttpMethod}
 * @ignore
 */
export let HttpMethod

/** @enum {HttpMethod} */
export const HTTP_METHODS = {
    get: /** @type {HttpMethod} */ ("GET"),
    head: /** @type {HttpMethod} */ ("HEAD"),
    post: /** @type {HttpMethod} */ ("POST"),
    put: /** @type {HttpMethod} */ ("PUT"),
    delete: /** @type {HttpMethod} */ ("DELETE"),
    connect: /** @type {HttpMethod} */ ("CONNECT"),
    options: /** @type {HttpMethod} */ ("OPTIONS"),
    trace: /** @type {HttpMethod} */ ("TRACE"),
    patch: /** @type {HttpMethod} */ ("PATCH"),
}
